export const voivodeship = [
    { label: 'Dolnośląskie', value: 'dol' },
    { label: 'Kujawsko-Pomorskie', value: 'kuj' },
    { label: 'Lubelskie', value: 'lub' },
    { label: 'Lubuskie', value: 'lbu' },
    { label: 'Łódzkie', value: 'lod' },
    { label: 'Małopolskie', value: 'mal' },
    { label: 'Mazowieckie', value: 'maz' },
    { label: 'Opolskie', value: 'opl' },
    { label: 'Podkarpackie', value: 'pdk' },
    { label: 'Podlaskie', value: 'pdl' },
    { label: 'Pomorskie', value: 'pom' },
    { label: 'Śląskie', value: 'sla' },
    { label: 'Świętokrzyskie', value: 'swk' },
    { label: 'Warmińsko-Mazurskie', value: 'war' },
    { label: 'Wielkopolskie', value: 'wlp' },
    { label: 'Zachodniopomorskie', value: 'zpm' },
];
